import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "26",
  height: "10",
  viewBox: "0 0 26 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("line", {
      y1: "1",
      x2: "26",
      y2: "1",
      stroke: "currentColor",
      "stroke-width": "2"
    }, null, -1),
    _createElementVNode("line", {
      y1: "9",
      x2: "26",
      y2: "9",
      stroke: "currentColor",
      "stroke-width": "2"
    }, null, -1)
  ])))
}
export default { render: render }